import type { Project } from '@/types/api'
import { create } from 'zustand'

interface ProjectState {
  projects: Project[]
  currentProject: string | null
  setProjects: (projects: Project[]) => void
  setCurrentProject: (code: string) => void
}

export const useProjectStore = create<ProjectState>(set => ({
  projects: [],
  currentProject: null,
  setProjects: projects => set({ projects }),
  setCurrentProject: code => set({ currentProject: code }),
}))
